import { forwardRef, type Ref, type SVGProps } from "react";
const IconProfileFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M17 11V2H7a2.006 2.006 0 0 0-2 2v24a2.006 2.006 0 0 0 2 2h18a2.006 2.006 0 0 0 2-2V12h-9a1 1 0 0 1-1-1m-9 5a2 2 0 0 1 2-2h1a2 2 0 1 1 2-2 2 2 0 0 1-2 2h1a2 2 0 0 1 2 2v1a1 1 0 0 1-2 0v-1h-2v1a1 1 0 0 1-2 0Zm8 10H9a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2m0-4H9a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2m5-6h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2m0 4h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2m0 4h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2" />
    <path d="m26 8.59-.29-.3-5-5-.3-.29A3.44 3.44 0 0 0 19 2.19V10h7.81A3.44 3.44 0 0 0 26 8.59" />
  </svg>
);
const ForwardRef = forwardRef(IconProfileFilledSVG);
ForwardRef.displayName = "IconProfileFilled";
export { ForwardRef as IconProfileFilled };
